import React from 'react';
import parse from 'html-react-parser';

export default function OptionTitle({title}) {
  return title && (<div className="app-option-title">{parse(title)}</div>);
};
